import { SCREEN_SIZE } from './app.state.models';

export class AppActions {
  static readonly seMaxtWidthScreen = class {
    static readonly type = '[app] set max width screen';
    constructor(public maxWidthScreen: number) {}
  };
  static readonly showLoader = class {
    static readonly type = '[app] show loader';
  };

  static readonly hideLoader = class {
    static readonly type = '[app] hide loader';
  };

  static readonly initLoader = class {
    static readonly type = '[app] init loader';
  };

  static readonly showError = class {
    static readonly type = '[app] show error';
    constructor(public error: string) {}
  };

  static readonly toastError = class {
    static readonly type = '[app] toast error';
    constructor(public error: Error) {}
  };

  static readonly setScreenSize = class {
    static readonly type = '[app] set screen size';
    constructor(public size: SCREEN_SIZE) {}
  };

  static readonly setUserInfos = class {
    static readonly type = '[app] set user infos from keycloak';
    constructor(public userInfos: any) {}
  };

  static readonly getMessagesExtensionsFrontReader = class {
    static readonly type = '[app] get extensions front reader';
  };

  static readonly logout = class {
    static readonly type = '[app] logout';
  };
    static toastSuccess: any;
}
